(function(){
  "use strict";
  var BASE = "https://nazranachikan.com/cdn/shop/files/";
  var imgs = [];
  var url = function(f,w){return BASE+f+"&width="+w;};
  var $ = function(s){return document.querySelector(s);};

  

  /* ---- quantity ---- */
  var qVal=$("#qVal");
  function clampQ(){ var v=parseInt(qVal.value,10)||1; v=Math.max(1,Math.min(5,v)); qVal.value=v;
    $("#qMinus").disabled=v<=1; $("#qPlus").disabled=v>=5; }
  $("#qMinus").addEventListener("click",function(){ qVal.value=(parseInt(qVal.value,10)||1)-1; clampQ(); });
  $("#qPlus").addEventListener("click",function(){ qVal.value=(parseInt(qVal.value,10)||1)+1; clampQ(); });
  qVal.addEventListener("input",clampQ); clampQ();

  /* ---- sticky bar quantity (1-3) ---- */
  var sbQVal=$("#sbQVal");
  function clampSbQ(){ var v=parseInt(sbQVal.value,10)||1; v=Math.max(1,Math.min(3,v)); sbQVal.value=v;
    $("#sbQMinus").disabled=v<=1; $("#sbQPlus").disabled=v>=3; }
  $("#sbQMinus").addEventListener("click",function(){ sbQVal.value=(parseInt(sbQVal.value,10)||1)-1; clampSbQ(); });
  $("#sbQPlus").addEventListener("click",function(){ sbQVal.value=(parseInt(sbQVal.value,10)||1)+1; clampSbQ(); });
  sbQVal.addEventListener("input",clampSbQ); clampSbQ();

  


/* ---- pincode ---- */
  $("#pinCheck").addEventListener("click",function(){
    var v=$("#pin").value.replace(/\D/g,"");
    var r=$("#pinResult");
    if(v.length!==6){ r.className="pinresult show"; r.style.color="var(--rose)"; r.textContent="Enter a valid 6-digit pincode."; return; }
    r.className="pinresult show"; r.style.color="var(--green-700)";
    r.innerHTML="Delivers between 5-7 days. Free shipping On Prepaid Orders.";
  });

  /* ---- accordion ---- */
  Array.prototype.forEach.call(document.querySelectorAll(".acc__item"), function(item){
    var btn=item.querySelector(".acc__btn"), panel=item.querySelector(".acc__panel");
    if(item.classList.contains("open")) panel.style.maxHeight=panel.scrollHeight+"px";
    btn.addEventListener("click",function(){
      var open=item.classList.contains("open");
      item.classList.toggle("open");
      panel.style.maxHeight = open?null:(panel.scrollHeight+"px");
    });
  });

  /* ---- size guide modal ---- */
  var sgModal=$("#sgModal");
  function sgClose(){ sgModal.classList.remove("show"); document.body.style.overflow=""; }
  $("#sizeGuideBtn").addEventListener("click",function(){ sgModal.classList.add("show"); document.body.style.overflow="hidden"; });
  $("#sgX").addEventListener("click",sgClose);
  sgModal.addEventListener("click",function(e){ if(e.target===sgModal) sgClose(); });

  /* ---- toast ---- */
  var toastWrap=$("#toastWrap");
  function toast(kind,title,sub){
    var t=document.createElement("div");
    t.className="toast toast--"+kind;
    var icon = kind==="cart" ? "✓" : "👜";
    t.innerHTML='<span class="ti">'+icon+'</span><span><b>'+title+'</b>'+(sub?'<small>'+sub+'</small>':'')+'</span>';
    toastWrap.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add("show"); });
    setTimeout(function(){ t.classList.remove("show"); setTimeout(function(){ t.remove(); },320); }, 3200);
  }

  /* ---- live viewers flicker ---- */
  var viewers=$("#viewers");
  setInterval(function(){
    var n=15+Math.floor(Math.random()*10); viewers.textContent=n;
  },4200);

  /* ---- social proof toasts ---- */
  var social=[
    ["Priya from Mumbai","just bought this kurti"],
    ["Sana from Delhi","added this to cart"],
    ["Meera from Pune","bought 2 × this style"],
    ["Anjali from Hyderabad","just bought this kurti"]
  ];
  var si=0;
  setTimeout(function tick(){
    var s=social[si%social.length]; si++;
    toast("social",s[0],s[1]);
    setTimeout(tick, 9000 + Math.random()*5000);
  }, 5000);

  /* ---- sticky mobile bar on scroll ---- */
  var sticky=$("#stickybar");
  window.addEventListener("scroll",function(){
    if(window.innerWidth>980){ sticky.classList.remove("show"); return; }
    sticky.classList.toggle("show", window.scrollY>520);
  },{passive:true});

  /* ---- reveal animations (bars + craft) via IntersectionObserver ---- */
  function animate(el){
    el.querySelectorAll(".fill").forEach(function(f){ f.style.width=f.dataset.w+"%"; });
    el.querySelectorAll(".craftbar i").forEach(function(i,idx){ setTimeout(function(){ i.style.width=(70+idx*8)+"%"; }, idx*150); });
  }
  if("IntersectionObserver" in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ animate(e.target); io.unobserve(e.target); } });
    },{threshold:.3});
    io.observe($("#bars")); io.observe($("#craftGrid"));
  } else { animate($("#bars")); animate($("#craftGrid")); }

  /* ---- related products ---- */
  var related=[
    {img:"1_39249ca1-4ea2-473f-9698-3215e82efc7e.jpg?v=1717571563", t:"Aadab Faux-Georgette Chikankari Anarkali", p:1950, s:2950},
    {img:"06_1080x1080_567ca080-b9a5-424a-abbe-37de3892a911.jpg?v=1707551143", t:"Aaliya Crepe Chikankari Kurti", p:3450},
    {img:"1_fdf0e4d2-8710-4e48-af6b-4779c52632bb.jpg?v=1745917026", t:"Aarvi Cotton Chikankari Kurti", p:3750},
    {img:"2_84a6873c-c37f-47a2-ba65-cb26b2ee9ebf.jpg?v=1777283883", t:"Yusra Viscose Georgette Chikankari Kurti", p:3950}
  ];
  var relgrid=$("#relgrid");
  related.forEach(function(r){
    var a=document.createElement("a");
    a.className="card"; a.href="#";
    a.innerHTML =
      '<div class="card__img"><img loading="lazy" alt="'+r.t+'" src="'+url(r.img,500)+'">'+
      '<button class="card__heart" aria-label="Save to wishlist">'+
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 20s-7-4.5-9-8.5C1.5 8 3 5 6 5c2 0 3 1.5 3 1.5S10 5 12 5s5 1.5 5 4.5c0 1.5-1 3-2 4"/></svg></button></div>'+
      '<div class="card__b"><div class="t">'+r.t+'</div><div class="p">'+fmt(r.p)+(r.s?' <s>'+fmt(r.s)+'</s>':'')+'</div></div>';
    a.querySelector(".card__heart").addEventListener("click",function(ev){
      ev.preventDefault(); ev.stopPropagation();
      var on=this.style.color==="rgb(156, 91, 78)";
      this.style.color=on?"":"var(--rose)";
    });
    relgrid.appendChild(a);
  });

  refreshPrice();
})();
